import { createFileRoute } from '@tanstack/react-router'

import { EntityListPage, entitiesQueryOptions /* , entityStatsQueryOptions */ } from '@/systems/entities'

export const Route = createFileRoute('/entities/')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(entitiesQueryOptions())
    // KPI stat cards removed from the entities page — no longer prefetched.
    // void queryClient.prefetchQuery(entityStatsQueryOptions('this_month'))
  },
  component: EntityListPage,
})
